import { voyageCamera } from './voyageCamera-sidecar'
import { voyageGameMode_tutorial } from './voyageGameMode_tutorial-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyagePicker } from './voyagePicker-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import { voyageUiGraphicsUtils } from './voyageUiGraphicsUtils-sidecar'
import { voyageUiTutorial } from './voyageUiTutorial-sidecar'

export interface IVoyageUiTutorial extends IVoyageUiCanvas {
  //slot: number
  //hoveredPart: IGoatShipPart | null

  header: string
  text: string
}

let _obj: IVoyageUiTutorial | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
  }
  return _obj
}
const create = () => {
  let tw = 0
  let th = 0
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IVoyageUiTutorial = voyageUiCanvas.assign<IVoyageUiTutorial>(
    canvas,
    {
      //slot: 1,
      //hoveredPart: null,
      header: 'Tutorial',
      text: 'Tutorial Text',
    },
  )

  return obj
}

export const setText = (h: string, t: string) => {
  let obj = get()
  obj.header = h
  obj.text = t
}

export const completeStep = () => {
  if (voyageGameMode_tutorial.getIsSkipped()) {
    return 0
  }

  let obj = get()
  obj.text += '\n\nGreat!'
  voyageSounds.playSuccess()
  return 1
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()
  voyageUiCanvas.setOpen(obj, isOpen)
}

export const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)

  let gb = voyageCamera.getGameBounds()

  let x = 500
  let y = 100

  let addText = (text: string, ox: number = 0, oy: number = 0) => {
    let t = voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3)
    y += 20
    return t
  }
  // let w = gb.width - 150 * 2
  // let h = 200
  // x = 150
  // y = gb.height - h - 20
  let w = 550
  let h = 250

  // goatGraphicsUtils.bevelPanelBackground(g, x, y, w, h)

  let vp = voyagePicker.get()
  let cr = vp.hoveredCrew || vp.selectedCrew
  let sys = vp.hoveredSystem

  voyageUiGraphicsUtils.bevelPanel2(g, x, y, w, h)
  x += 20
  y += 20
  addText(obj.header, 6, 0)
  y += 20
  x += 30
  addText(obj.text)

  y += 150
  if (!voyageGameMode_tutorial.getIsSkipped()) {
    addText('To skip tutorial, press X')
  }

  voyageUiCanvas.render(obj)
}

export const update = () => {
  let obj = get()
  if (obj.isOpen) {
    voyageUiCanvas.update(obj)
    render()
  } else {
    voyageUiCanvas.clear(obj)
  }
}
